// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__17ghV"};